export default "__VITE_ASSET__D2N09T_r__"